var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendMessage = function SvgSendMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.085 11.366c.002.53-.151 1.05-.44 1.495-.28.45-.688.806-1.17 1.025l-13.56 6.575c-.378.19-.795.288-1.217.287q-.266 0-.527-.058a2.74 2.74 0 0 1-1.534-.862 2.79 2.79 0 0 1-.306-3.335l3.296-4.58c.077-.183.116-.378.115-.576a1.4 1.4 0 0 0-.143-.613L2.55 6.41a2.75 2.75 0 0 1-.374-1.744 2.77 2.77 0 0 1 2.205-2.405 2.88 2.88 0 0 1 1.715.191l13.417 6.392a2.81 2.81 0 0 1 1.571 2.52"
  })));
};
export default SvgSendMessage;